<template>
  <section class="verification">
    <aside class="aside-head">
      <img
        src="https://res.cloudinary.com/dyikvzcke/image/upload/v1757700980/Frame_395_mmgg6f.png"
        alt="Imagen verificaion SKF"
      />
    </aside>
    <aside class="aside-content">
      <div>
        <h2>Distribuidor autorizado SKF</h2>
        <p>
          Con <b>35 años de experiencia</b> en el sector, seguimos orgullosos de
          ser
          <b>
            distribuidores los productos de SKF, un nombre líder en rodamientos
            y soluciones industriales
          </b>
          . La calidad y fiabilidad de SKF siguen siendo un pilar clave en
          nuestra oferta.
        </p>
      </div>
      <img src="https://res.cloudinary.com/dyikvzcke/image/upload/v1757700837/SKF_distribuidor-autorizado-horizontal_mu1hye.png" alt="" />
    </aside>
  </section>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.verification {
  margin-inline: 300px;
  margin-top: 120px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  .aside-head {
    img {
      width: 100%;
    }
  }
  .aside-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 100px;
    padding-block: 80px;
    padding-inline: 60px;
    div {
      display: flex;
      flex-direction: column;
      gap: 30px;
      text-align: start;
      width: 500px;
    }
    h2 {
      font-size: 36px;
      font-weight: 600;
      line-height: normal;
    }
    p {
      color: rgba(7, 23, 37, 0.6);
      font-size: 18px;
    line-height: 24px;
      font-weight: 400;
    }
    img {
      width: 400px;
      object-fit: contain;
    }
  }
}

@media (max-width: 1600px) {
  .verification {
    margin-inline: 100px;
    gap: 50px;
    .aside-content {
      padding-inline: 40px;
      h2 {
        font-size: 32px;
      }
      p {
        font-size: 16px;
      }
      img {
        width: 320px;
      }
    }
  }
}
@media (max-width: 1080px) {
  .verification {
    margin-inline: 80px;
    .aside-head {
      display: none;
    }
    .aside-content {
      flex-direction: column;
      align-items: center;
      h2 {
        font-size: 24px;
      }
    }
    .aside-content div {
      width: 100%;
    }
  }
}
@media (max-width: 580px) {
  .verification {
    margin-inline: 20px;
    .aside-content {
      padding-inline: 20px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
